import {
	connect
} from 'react-redux'
import Fitting1Component from '../components/Fitting1Component.jsx';
import {
	changeFitting1OrderId,
	changeFitting1EventKey,
	findAllOrderIds,
	findOrderDetailBespokeList,
	clearFitting1Data,
	findOrderAppCheckList,
	changeShowAppCheckDiv
} from '../actions';

const mapStateToProps = (state) => ({
	orderId: state.getIn(['fitting1Reducer', 'orderId']),
	allOrderIds: state.getIn(['fitting1Reducer', 'allOrderIds']),
	eventKey: state.getIn(['fitting1Reducer', 'eventKey']),
	roles: state.getIn(['authReducer', 'roles'])
})

const mapDispatchToProps = (dispatch) => ({
	changeOrderId: (payload) => {
		dispatch(changeFitting1OrderId(payload));
	},
	changeEventKey: (key) => {
		dispatch(changeFitting1EventKey(key));
	},
	findAllOrderIds: () => {
		dispatch(findAllOrderIds());
	},
	findOrderDetailBespokeList: (payload) => {
		dispatch(findOrderDetailBespokeList(payload));
	},
	clearFitting1Data: () => {
		dispatch(clearFitting1Data());
	},
	findOrderAppCheckList: (payload) => {
		dispatch(findOrderAppCheckList(payload));
	},
	changeShowAppCheckDiv: (payload) => {
		dispatch(changeShowAppCheckDiv(payload));
	},
})

const Fitting1Container = connect(
	mapStateToProps,
	mapDispatchToProps
)(Fitting1Component)

export default Fitting1Container;


// WEBPACK FOOTER //
// ./src/containers/Fitting1Container.jsx